import React from "react";

const THEME_LIST = [
  { key: "", label: "Brand (Mặc định)" },
  { key: "theme-flat", label: "Flat" },
  { key: "theme-soft", label: "Soft" },
  { key: "theme-dark", label: "Dark" },
  { key: "theme-bright", label: "Bright" },
  { key: "theme-navy-cyan", label: "Navy" },
];

const ThemeSwitcher = ({ theme, setTheme, label = "Theme" }) => (
  <div className="mt-4">
    <label htmlFor="theme-select" className="block mb-1 font-semibold text-text2">
      {label}
    </label>
    <select
      id="theme-select"
      value={theme}
      onChange={(e) => setTheme(e.target.value)}
      className="border border-border rounded bg-card px-2 py-1 text-sm focus:ring-2 focus:ring-primary/30 transition"
    >
      {THEME_LIST.map((th) => (
        <option value={th.key} key={th.key}>{th.label}</option>
      ))}
    </select>
  </div>
);

export default ThemeSwitcher;
